import React from "react";
import styles from "./stats-card.module.scss";
import Card from ".";

const StatsCard = ({ title, method }) => {
  const [value, setValue] = React.useState("-");
  const [loaded, setLoaded] = React.useState(false);

  const fetchValue = React.useCallback(async () => {
    if (!loaded) {
      try {
        const response = await method();
        setValue(response);
      } catch (e) {
        setValue("NA");
      } finally {
        setLoaded(true);
      }
    }
  }, [method, loaded]);

  React.useEffect(() => {
    fetchValue();
  }, [fetchValue]);
  return (
    <Card className={styles.container}>
      <span className={styles.title}>{title}</span>
      <span className={styles.value}>{value}</span>
    </Card>
  );
};

export default StatsCard;
